import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { NetzBalken } from "./netzstand";
import { NeueFassungBalken } from "./servicearbeiter";
import "./i18n";
import "./brand.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/*
      Der Hinweis auf eine neue Fassung steht ueber der Anwendung, damit er
      auch vor der Anmeldung erscheint.
    */}
    <NeueFassungBalken />
    {/*
      Der Netzstand steht ebenfalls ueber der Anwendung. Er gehoert nicht auf
      eine einzelne Seite: eine wartende Eingabe geht jeden Bildschirm an.
    */}
    <NetzBalken />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
